export default "__VITE_ASSET__B2GGvg3w__"